import React from 'react';
import DocumentModuleV2 from './DocumentModuleV2';

export default function SalesV2() {
  return (
    <DocumentModuleV2 kind="sales" title="Sales" counterpartyLabel="Buyer" />
  );
}
